/*
 * @Author: huangziyin
 * @Date: 2025-03-18 19:23:15
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-03-20 19:55:39
 * @Description: 请填写简介
 */
const historyMap = {
  // 获取收藏列表
  getCollectList: '/usb/uwb-app/api/v1/collect/page',
  // 获取浏览历史
  getHistoryList: '/usb/uwb-app/api/v1/browsingHistory/list',
  // 添加到收藏
  addCollect: '/usb/uwb-app/api/v1/collect/add',
  // 取消收藏
  deleteCollect: '/usb/uwb-app/api/v1/collect/delete',
  // 删除浏览历史
  deleteHistory: '/usb/uwb-app/api/v1/browsingHistory/delete',
  // 新增浏览历史
  addHistory: '/usb/uwb-app/api/v1/browsingHistory/save',
};

export default historyMap;
